if (!customElements.get('count-down')) {
  customElements.define(
        'count-down',
        class Countdown extends HTMLElement {
          static get observedAttributes() {
            return ['end', 'date', 'time', 'tz-mode', 'tz-offset', 'expired'];
          }

          constructor() {
            super();
            this._end = null;
            this._ticker = null;

            const wrapper = document.createElement('div');
            wrapper.setAttribute('role', 'timer');
            wrapper.setAttribute('aria-live', 'polite');

            const grid = document.createElement('ul');
            grid.className = 'cdn-grid';
            grid.innerHTML = [
              '<li class="seg seg-days"><span class="num">0</span>d</li>',
              '<li class="seg seg-hours"><span class="num">0</span>h</li>',
              '<li class="seg seg-mins"><span class="num">0</span>m</li>',
              '<li class="seg seg-secs"><span class="num">0</span>s</li>'
            ].join(' ');

            wrapper.appendChild(grid);
            this.appendChild(wrapper);

            this.$ = {
              host:  wrapper,
              grid,
              days:  grid.querySelector('.seg-days .num'),
              hours: grid.querySelector('.seg-hours .num'),
              mins:  grid.querySelector('.seg-mins .num'),
              secs:  grid.querySelector('.seg-secs .num')
            };
          }

          connectedCallback() {
            this._applyAttributes();
            this._start();
          }

          disconnectedCallback() { this._stop(); }

          attributeChangedCallback() {
            this._applyAttributes();
            this._restart();
          }

          _applyAttributes() {
            const isoEnd   = this.getAttribute('end');
            const dateStr  = (this.getAttribute('date') || '').trim();     // MM/DD/YY
            const timeStr  = (this.getAttribute('time') || '00:00').trim(); // HH:MM 24h
            const tzMode   = (this.getAttribute('tz-mode') || 'visitor').trim(); // visitor|utc|offset
            const tzOffset = (this.getAttribute('tz-offset') || '+00:00').trim(); // ±HH:MM
            const expired  = this.getAttribute('expired');

            let end = null;
            if (isoEnd) {
              const d = new Date(isoEnd);
              if (!isNaN(d.getTime())) end = d;
            } else {
              end = this._buildDateFromParts(dateStr, timeStr, tzMode, tzOffset);
            }

            if (end && !isNaN(end.getTime())) {
              this._end = end;
              this.style.display = '';
            } else {
              this._end = null;
              this.style.display = 'none';
            }
          }

          _start() { if (!this._end) return; this._stop(); this._update(); this._ticker = setInterval(() => this._update(), 1000); }
          _restart() { this._stop(); this._start(); }
          _stop() { if (this._ticker) { clearInterval(this._ticker); this._ticker = null; } }

          _plural(n, s){ return n === 1 ? s : s + 's'; }

          _parseTime(timeStr){
            const m = timeStr.match(/^(\d{2}):(\d{2})$/);
            if (!m) return null;
            const h = parseInt(m[1], 10);
            const mi = parseInt(m[2], 10);
            if (h < 0 || h > 23 || mi < 0 || mi > 59) return null;
            return { h, m: mi, s: 0 };
          }

          _parseOffset(offsetStr){
            const m = offsetStr.match(/^([+-])(\d{2}):(\d{2})$/);
            if (!m) return 0;
            const sign = m[1] === '-' ? -1 : 1;
            const hh = Math.min(23, parseInt(m[2],10)||0);
            const mm = Math.min(59, parseInt(m[3],10)||0);
            return sign * (hh * 60 + mm);
          }

          _parseDate(dateStr){
            const m = (dateStr || '').trim().match(/^(\d{2})\/(\d{2})\/(\d{2})$/);
            if (!m) return null;
            const mm = parseInt(m[1],10), dd = parseInt(m[2],10), yy2 = parseInt(m[3],10);
            if (mm < 1 || mm > 12 || dd < 1 || dd > 31) return null;
            const yyyy = 2000 + yy2;
            return { y: yyyy, m: mm, d: dd };
          }

          _buildDateFromParts(dateStr, timeStr, tzMode, tzOffset){
            const dparts = this._parseDate(dateStr);
            const tparts = this._parseTime(timeStr);
            if (!dparts || !tparts) return null;
            const { y, m, d } = dparts;
            const { h, m: mi, s } = tparts;

            if (tzMode === 'utc') {
              return new Date(Date.UTC(y, m-1, d, h, mi, s));
            }
            if (tzMode === 'offset') {
              const offMin = this._parseOffset(tzOffset);
              const localAsUTC = Date.UTC(y, m-1, d, h, mi, s);
              const utcMs = localAsUTC - (offMin * 60 * 1000);
              return new Date(utcMs);
            }
            return new Date(y, m-1, d, h, mi, s);
          }

          _update(){
            const end = this._end;
            if (!end) return;
            const now = new Date();
            const diffMs = end.getTime() - now.getTime();

            if (diffMs <= 0) {
              this.remove();
              return;
            }

            let total = Math.floor(diffMs / 1000);
            const days  = Math.floor(total / 86400); total -= days * 86400;
            const hours = Math.floor(total / 3600);  total -= hours * 3600;
            const mins  = Math.floor(total / 60);    total -= mins * 60;
            const secs  = total;

            if (this.$.days)  this.$.days.textContent  = String(days);
            if (this.$.hours) this.$.hours.textContent = String(hours);
            if (this.$.mins)  this.$.mins.textContent  = String(mins);
            if (this.$.secs)  this.$.secs.textContent  = String(secs);

            const aria = `${days} ${this._plural(days,'day')}, ${hours} ${this._plural(hours,'hour')}, ${mins} ${this._plural(mins,'minute')}, ${secs} ${this._plural(secs,'second')} remaining`;
            this.$.host.setAttribute('aria-label', aria);
          }
        }
      );
}
